/**
 * Client related pages
 */

import ClientList from '@/components/client/ClientList.vue';
import Outcome from '@/components/client/ClientOutcome.vue';
import ClientProfile from '@/components/client/ClientProfile.vue';
import Record from '@/components/client/ClientRecord.vue';
import NewClient from '@/components/client/NewClientForm.vue';
import Participation from '@/components/client/ParticipationRecord.vue';
import HUBApi from '@/service/hub-api';
import HUBStore from '@/store';
import HUBLog from '@/utils/logger';
import HUBValidation from '@/utils/validation';

const clientRouter = {
  routes: [
    {
      path: '/client/list',
      name: 'clientList',
      component: ClientList,
    },
    {
      path: '/client/new',
      name: 'newClient',
      component: NewClient,
    },
    {
      path: '/client/pro/:clientId',
      component: ClientProfile,
      children: [
        {
          path: '',
          redirect: { name: 'participation' },
        },
        {
          path: 'record',
          name: 'record',
          component: Record,
        },
        {
          path: 'participation',
          name: 'participation',
          component: Participation,
        },
        {
          path: 'outcome',
          name: 'outcome',
          component: Outcome,
        },
      ],
    },
  ],
};

clientRouter.routes.forEach((r) => {
  const route = r;
  route.props = true;
});

clientRouter.guard = async (to, from) => {
  // Not a client page
  // Pass to next guard
  if (!HUBValidation.validateRoute(to.name, clientRouter.routes)) {
    return;
  }

  const HUBSettingItems = {
    currentFunction: {
      key: 'client-service',
      name: 'Client Service',
    },
  };

  if (to.name === 'clientList') {
    HUBSettingItems.levelUp = { name: 'dashboard' };
  } else if (to.name === 'newClient') {
    HUBSettingItems.levelUp = { name: 'clientList' };
  } else if (to.params.clientId) {
    const clientResult = await HUBApi.get(`/clients/${to.params.clientId}`);
    const [currentClient] = clientResult.records;

    if (!currentClient) {
      HUBLog.debug(`Back to: ${from.path}`);
      throw new Error('$Reject');
    }

    HUBSettingItems.currentClient = currentClient;
    HUBSettingItems.levelUp = { name: 'clientList' };
  }

  HUBStore.commit('setHUBSettingItems', HUBSettingItems);

  HUBLog.debug(`Access: ${to.path}`);
  throw new Error();
};

export default clientRouter;
